/* ===== Catálogo padrão do menu lateral =====
 *
 * Fonte única da verdade, usada em dois lugares:
 *   - Sidebar.js, para desenhar o menu;
 *   - MenuBuilder, onde um representante reordena/agrupa esses itens para a
 *     carteira dele.
 *
 * `permission` e `typeCompany` moram AQUI e só aqui. O layout personalizado
 * referencia um item pelo `link` e pode mudar rótulo, ícone, ordem e
 * agrupamento — nunca o recorte de acesso. É isso que impede um representante
 * de abrir uma tela administrativa para os clientes dele arrastando um item.
 */

export const DEFAULT_MENU = [
  {
    name: "Visão Geral",
    link: "/dashboard",
    icon: "equalizer",
    permission: ["USER", "USER_CALENDARS"],
    isCollapsible: false,
    typeCompany: ["ALL"],
  },
  {
    name: "Consulte aqui",
    link: "/queries",
    icon: "manage_search",
    permission: ["USER"],
    isCollapsible: true,
    typeCompany: ["ALL"],
    children: [
      {
        name: "Créditos",
        link: "/queries/credits",
        icon: "attach_money",
        permission: ["USER"],
        isCollapsible: false,
        typeCompany: ["ALL"],
      },
      {
        name: "Cadastrais",
        link: "/queries/cadastrals",
        icon: "account_box",
        permission: ["USER"],
        isCollapsible: false,
        typeCompany: ["ALL"],
      },
      {
        name: "Veiculares",
        link: "/queries/autos",
        icon: "time_to_leave",
        permission: ["USER"],
        isCollapsible: false,
        typeCompany: ["ALL"],
      },
    ],
  },
  /* Motor de crédito saiu de dentro de "Consulte aqui": escondido no submenu
     quase ninguém abria. Como item de topo, logo abaixo da consulta, ele
     aparece sozinho e o rótulo fala do resultado ("decida com segurança"),
     não do nome interno da ferramenta. */
  {
    name: "Decida com segurança",
    link: "/credit-engine",
    icon: "verified_user",
    permission: ["USER"],
    isCollapsible: false,
    typeCompany: ["ALL"],
  },
  {
    name: "Negative Clientes",
    link: "/negatives",
    icon: "thumb_down_alt",
    permission: ["USER"],
    isCollapsible: false,
    typeCompany: ["ALL"],
  },
  // {
  //   name: "Gerenciamento de carteira",
  //   link: "/gerenciamento-de-carteira",
  //   icon: "radar",
  //   permission: ["USER"],
  //   isCollapsible: false,
  //   typeCompany: ["ALL"],
  // },
  {
    name: "Localizador PF/PJ",
    link: "/localize",
    icon: "travel_explore",
    permission: ["USER"],
    isCollapsible: false,
    typeCompany: ["ALL"],
  },
  // {
  //   name: "Cobre seus clientes",
  //   link: "/cobrancas",
  //   icon: "receipt_long",
  //   permission: ["USER"],
  //   isCollapsible: false,
  //   typeCompany: ["ALL"],
  // },

  {
    name: "Relatórios",
    link: "/reports",
    icon: "query_stats",
    permission: ["USER"],
    isCollapsible: true,
    typeCompany: ["ALL"],
    children: [
      {
        name: "Consultas",
        link: "/reports/queries",
        icon: "manage_search",
        permission: ["USER"],
        isCollapsible: false,
        typeCompany: ["ALL"],
      },
    ],
  },

  {
    name: "Minhas Faturas",
    link: "/invoices",
    icon: "request_quote",
    permission: ["ADMIN"],
    isCollapsible: false,
    typeCompany: ["ALL"],
  },
  {
    name: "Usuários",
    link: "/users",
    icon: "group",
    permission: ["ADMIN"],
    isCollapsible: false,
    typeCompany: ["ALL"],
  },
  {
    name: "Suporte",
    link: "/support",
    icon: "support_agent",
    permission: ["USER"],
    isCollapsible: false,
    typeCompany: ["ALL"],
  },
  {
    name: "Administrativo",
    link: "/admin",
    icon: "settings",
    permission: ["ADMIN"],
    isCollapsible: true,
    typeCompany: ["REPRESENTANTE", "ADMIN"],
    children: [
      {
        name: "Review ⭐",
        link: "/admin/daily-review",
        icon: "stacked_bar_chart",
        permission: ["ADMIN"],
        isCollapsible: false,
        typeCompany: ["REPRESENTANTE", "ADMIN"],
      },
      {
        name: "Relatórios",
        link: "/admin/reports",
        icon: "query_stats",
        permission: ["ADMIN"],
        isCollapsible: false,
        typeCompany: ["REPRESENTANTE", "ADMIN"],
      },
      // {
      //   name: "Gerenciamento de Carteira",
      //   link: "/admin/monitored-clients",
      //   icon: "radar",
      //   permission: ["ADMIN"],
      //   isCollapsible: false,
      //   typeCompany: ["REPRESENTANTE", "ADMIN"],
      // },
      {
        name: "Negativações",
        link: "/admin/negatives",
        icon: "policy",
        permission: ["POWER_USER", "ADMIN"],
        isCollapsible: false,
        typeCompany: ["REPRESENTANTE", "ADMIN"],
      },
      {
        name: "Aprovar cobranças",
        link: "/admin/cobrancas",
        icon: "fact_check",
        permission: ["POWER_USER", "ADMIN"],
        isCollapsible: false,
        typeCompany: ["REPRESENTANTE", "ADMIN"],
      },

      {
        name: "Financeiro",
        link: "/admin/invoices",
        icon: "receipt",
        permission: ["ADMIN"],
        isCollapsible: false,
        typeCompany: ["REPRESENTANTE", "ADMIN"],
      },
      {
        name: "Clientes",
        link: "/admin/customers",
        icon: "person",
        permission: ["ADMIN"],
        isCollapsible: false,
        typeCompany: ["REPRESENTANTE", "ADMIN"],
      },
      {
        name: "Representantes",
        link: "/admin/representatives",
        /* "group_2" é Material Symbols e o painel carrega a fonte clássica
           Material Icons: a ligadura não vira glifo e aparece como texto
           cortado pela caixa de 1em do Icon.js. "groups" existe na clássica e
           é o mesmo desenho. */
        icon: "groups",
        permission: ["ADMIN"],
        isCollapsible: false,
        typeCompany: ["REPRESENTANTE", "ADMIN"],
      },
      {
        name: "Tabela de Custos",
        link: "/admin/table-cost",
        icon: "request_page",
        permission: ["ADMIN"],
        isCollapsible: false,
        typeCompany: ["REPRESENTANTE", "ADMIN"],
      },
      {
        name: "Banners",
        link: "/admin/banners",
        icon: "image",
        permission: ["ADMIN"],
        isCollapsible: false,
        typeCompany: ["REPRESENTANTE", "ADMIN"],
      },
      {
        name: "Notificações",
        link: "/admin/notifications",
        icon: "notifications_active",
        permission: ["POWER_USER"],
        isCollapsible: false,
        typeCompany: ["ADMIN"],
      },
      {
        name: "Chamados",
        link: "/admin/support",
        icon: "confirmation_number",
        permission: ["ADMIN"],
        isCollapsible: false,
        typeCompany: ["REPRESENTANTE", "ADMIN"],
      },

      {
        name: "Configurações",
        link: "/admin/admin",
        icon: "settings_suggest",
        permission: ["ADMIN"],
        isCollapsible: false,
        typeCompany: ["REPRESENTANTE", "ADMIN"],
      },
    ],
  },
];

/* ===== MENU PROVEDOR =====
 *
 * Um item só, e é o ponto: PROVIDER é um acesso de FORA da casa — o
 * responsável por um provedor entrando para conferir o que consumimos dele.
 * Ele não é cliente, não consulta nada e não enxerga carteira nenhuma.
 *
 * Esconder o resto do menu é conforto, não segurança: quem garante o recorte é
 * o backend (restrictProviderUser nega toda rota fora de /provider-portal). */
export const DEFAULT_PROVIDER_MENU = [
  {
    name: "Consumo do provedor",
    link: "/provedor/consumo",
    icon: "query_stats",
    permission: ["PROVIDER"],
    isCollapsible: false,
    typeCompany: ["ALL"],
  },
];

/* ===== MENU SELLER (sem o "Administrativo") ===== */
export const DEFAULT_SELLER_MENU = [
  {
    name: "Dashboard",
    link: "/dashboard",
    icon: "equalizer",
    permission: ["USER", "USER_CALENDARS"],
    isCollapsible: false,
    typeCompany: ["ALL"],
  },
  {
    name: "Consultas",
    link: "/queries",
    icon: "manage_search",
    permission: ["USER"],
    isCollapsible: true,
    typeCompany: ["ALL"],
    children: [
      {
        name: "Créditos",
        link: "/queries/credits",
        icon: "attach_money",
        permission: ["USER"],
        isCollapsible: false,
        typeCompany: ["ALL"],
      },
      {
        name: "Cadastrais",
        link: "/queries/cadastrals",
        icon: "account_box",
        permission: ["USER"],
        isCollapsible: false,
        typeCompany: ["ALL"],
      },
      {
        name: "Veiculares",
        link: "/queries/autos",
        icon: "time_to_leave",
        permission: ["USER"],
        isCollapsible: false,
        typeCompany: ["ALL"],
      },
    ],
  },
  {
    name: "Decida com segurança",
    link: "/credit-engine",
    icon: "verified_user",
    permission: ["USER"],
    isCollapsible: false,
    typeCompany: ["ALL"],
  },
  {
    name: "Localizador PF/PJ",
    link: "/localize",
    icon: "travel_explore",
    permission: ["USER"],
    isCollapsible: false,
    typeCompany: ["ALL"],
  },
  // {
  //   name: "Cobre seus clientes",
  //   link: "/cobrancas",
  //   icon: "receipt_long",
  //   permission: ["USER"],
  //   isCollapsible: false,
  //   typeCompany: ["ALL"],
  // },
  {
    name: "Negative Clientes",
    link: "/negatives",
    icon: "thumb_down_alt",
    permission: ["USER"],
    isCollapsible: false,
    typeCompany: ["ALL"],
  },
  // {
  //   name: "Gerenciamento de carteira",
  //   link: "/gerenciamento-de-carteira",
  //   icon: "radar",
  //   permission: ["USER"],
  //   isCollapsible: false,
  //   typeCompany: ["ALL"],
  // },
  {
    name: "Relatórios",
    link: "/reports",
    icon: "query_stats",
    permission: ["USER"],
    isCollapsible: true,
    typeCompany: ["ALL"],
    children: [
      {
        name: "Consultas",
        link: "/reports/queries",
        icon: "manage_search",
        permission: ["USER"],
        isCollapsible: false,
        typeCompany: ["ALL"],
      },
    ],
  },

  // ✅ novo item só para SELLER
  {
    name: "Meus Clientes",
    link: "/my-customers",
    icon: "groups_3",
    permission: ["SELLER"],
    isCollapsible: false,
    typeCompany: ["ALL"],
  },

  {
    name: "Dúvidas Frequentes",
    link: "/faq",
    icon: "help_outline",
    permission: ["USER"],
    isCollapsible: false,
    typeCompany: ["ALL"],
  },
  {
    name: "Suporte",
    link: "/support",
    icon: "support_agent",
    permission: ["USER"],
    isCollapsible: false,
    typeCompany: ["ALL"],
  },
];

/* Itens de topo que o representante NÃO monta.
 *
 * "Administrativo" é a caixa de ferramentas de quem opera a plataforma: fica
 * fora do editor, aparece sempre e sempre na mesma posição. Deixá-lo arrastável
 * só criaria formas de um representante esconder de si mesmo — ou de um par —
 * a tela de que precisa para trabalhar, sem ganho nenhum para a carteira, que
 * nem enxerga esses itens.
 *
 * A consequência prática atravessa as três camadas: o editor não oferece esses
 * links, o layout salvo não pode referenciá-los (o backend recusa) e o menu os
 * reinsere na posição original depois de aplicar o que o representante montou.
 */
export const FIXED_MENU_LINKS = new Set(["/admin"]);

const isFixed = (item) => FIXED_MENU_LINKS.has(item?.link);

/* Os itens fixos com a posição que ocupam no catálogo, para o menu recolocá-los
   exatamente onde estavam depois de aplicar o layout personalizado. */
export const getFixedMenuItems = (catalog = DEFAULT_MENU) =>
  catalog
    .map((item, index) => ({ item, index }))
    .filter(({ item }) => isFixed(item));

/* Lista plana dos DESTINOS do catálogo, para a tela de montagem: os itens de
   topo mais os filhos dos submenus, porque um representante pode querer
   "Veiculares" solto no primeiro nível em vez de dentro de "Consulte aqui".

   Item que tem filhos fica de fora: "/queries", "/reports" e "/admin" não são
   rotas — existem só para abrir o accordion (veja AppRouter, que registra
   "queries/credits" e nunca "queries"). Oferecê-los como item avulso produziria
   uma linha de menu que não leva a lugar nenhum. Quem quiser a estrutura deles
   usa catalogToLayout abaixo, que os converte em grupo.

   `parentName` existe só para o editor mostrar de onde o item veio — dois itens
   chamados "Consultas" em grupos diferentes seriam indistinguíveis na lista. */
export const flattenCatalog = (items = DEFAULT_MENU, parentName = null) =>
  items.flatMap((item) => {
    if (isFixed(item)) return [];
    if (item.children?.length) return flattenCatalog(item.children, item.name);

    return item.link
      ? [
          {
            link: item.link,
            name: item.name,
            icon: item.icon,
            parentName,
            permission: item.permission,
            typeCompany: item.typeCompany,
          },
        ]
      : [];
  });

/* Converte o catálogo padrão no formato de layout do editor.
 *
 * Serve para a tela de montagem abrir já com o menu padrão em vez de uma lista
 * vazia: o representante ajusta o que existe em vez de remontar tudo do zero.
 *
 * Submenu vira grupo, e isso não perde nada: no Sidebar, item com filhos
 * renderiza um botão que abre o accordion, nunca um link — então o `link` do
 * pai já não era navegável antes da conversão. */
export const catalogToLayout = (items = DEFAULT_MENU) =>
  items
    .filter((item) => !isFixed(item))
    .map((item) =>
      item.children?.length
        ? {
            type: "group",
            name: item.name,
            icon: item.icon,
            children: item.children.map((child) => ({
              type: "item",
              link: child.link,
            })),
          }
        : { type: "item", link: item.link },
    );
